export const FORM_DETAIL_STRINGS = {
  CLOSE_FORM: 'Cancel Progress?',
  CLOSE_FORM_SUBHEADING: 'If you exit the form, you will lose all progress on your submission.',
  CLOSE_FORM_SAVE_TEXT: 'Exit Form',
  CLOSE_FORM_CANCEL_TEXT: 'No, Continue with Form',
} as const;
